// Regras do onboarding Visor (D64), sem Vue: passos, barra, checklist e o
// estado do WhatsApp. Base para toda conta; imóveis e teste da IA entram só
// com o Módulo Imobiliária.

const BASE_STEPS = ['boas_vindas', 'aparencia', 'contas'];
const REAL_ESTATE_STEPS = ['imoveis', 'teste_ia'];

export const STEP_ICONS = {
  boas_vindas: 'i-ph-house-line-duotone',
  aparencia: 'i-ph-palette-duotone',
  contas: 'i-ph-link-duotone',
  imoveis: 'i-ph-buildings-duotone',
  teste_ia: 'i-ph-chat-circle-dots-duotone',
  painel: 'i-ph-chart-bar-duotone',
};

export const stepsFor = ({ realEstate }) => [
  ...BASE_STEPS,
  ...(realEstate ? REAL_ESTATE_STEPS : []),
  'painel',
];

// A conta já existe quando o fluxo abre: a barra começa em 20% e chega a 100%
// no painel.
export const progressFor = (index, total) => {
  if (total <= 1) return 100;
  return Math.round(20 + (80 * index) / (total - 1));
};

export const whatsappDone = state =>
  Boolean(state?.whatsapp?.has_inbox || state?.progress?.whatsapp_connected);

const doneSteps = state => state?.progress?.done || [];

// Seis passos; "equipe" é opcional e só vira o próximo quando o resto acabou.
export const checklistFor = state => {
  const done = doneSteps(state);
  const items = [
    { key: 'conta', done: true },
    { key: 'dados', done: done.includes('boas_vindas'), step: 'boas_vindas' },
    state?.real_estate
      ? { key: 'contas', done: whatsappDone(state), step: 'contas' }
      : {
          key: 'aparencia',
          done: done.includes('aparencia'),
          step: 'aparencia',
        },
    state?.real_estate
      ? { key: 'imoveis', done: done.includes('imoveis'), step: 'imoveis' }
      : { key: 'whatsapp', done: whatsappDone(state), step: 'contas' },
    { key: 'primeira_conversa', done: Boolean(state?.has_conversations) },
    { key: 'equipe', done: (state?.agents_count || 0) > 1, optional: true },
  ];
  const next =
    items.find(item => !item.done && !item.optional) ||
    items.find(item => !item.done);
  return items.map(item => ({ ...item, next: item === next }));
};

export const checklistCount = items => items.filter(item => item.done).length;

// Estados da sessão WAHA na linguagem da tela. "trazendo" é a primeira leitura
// de WORKING, quando o WhatsApp ainda sincroniza as conversas.
export const WHATSAPP_STAGES = ['aguardando', 'lido', 'trazendo', 'conectado'];

export const whatsappStage = (status, previous) => {
  if (status === 'WORKING') {
    return ['trazendo', 'conectado'].includes(previous)
      ? 'conectado'
      : 'trazendo';
  }
  // Depois do QR na tela, STARTING quer dizer que o celular leu o código.
  if (status === 'STARTING' && ['aguardando', 'lido'].includes(previous)) {
    return 'lido';
  }
  if (status === 'SCAN_QR_CODE') return 'aguardando';
  if (['FAILED', 'ERROR', 'STOPPED'].includes(status)) return 'erro';
  return previous || 'preparando';
};

export const greetingKey = (date = new Date()) => {
  const hour = date.getHours();
  if (hour < 12) return 'MORNING';
  if (hour < 18) return 'AFTERNOON';
  return 'EVENING';
};
